import LinkButton from "ds/components/Button/LinkButton";
import Feedback from "ds/components/Feedback";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { pluralize } from "shared/Pluralize";
import { BillingTier } from "types/generated";
import { SubscriptionContext } from "views/Account/SubscriptionWrapper";

import { SettingsContext } from "../Context";
import { UserManagementActivationStatus } from "../types";
import { SeatLimitsNotificationEntity } from "./types";

const SeatLimitsNotificationLoginPolicies = () => {
  const { tier } = useTypedContext(SubscriptionContext);
  const { activationStatus, seats } = useTypedContext(SettingsContext);
  const { october2026PricingChanges } = useTypedFlags();

  if (activationStatus === UserManagementActivationStatus.ACTIVE) {
    return null;
  }

  const userSeats = seats.user;
  const apiKeySeats = seats.apiKey;

  if (userSeats.limit === -1) {
    return null;
  }

  const isFreeTier = tier === BillingTier.V4Free || tier === BillingTier.V5Free;
  const isStarterTier = tier === BillingTier.V4Starter || tier === BillingTier.V5Starter;

  if (!isFreeTier && !isStarterTier) {
    return null;
  }

  const upgradeTierName = october2026PricingChanges ? "Business" : "Starter+";

  return (
    <Feedback type="callout" variant="promo" title="Upgrade to unlock more seats">
      {isFreeTier && (
        <>
          Free tier has{" "}
          <strong>
            {userSeats.limit} {pluralize(SeatLimitsNotificationEntity.User, userSeats.limit)} and{" "}
            {apiKeySeats.limit} {pluralize(SeatLimitsNotificationEntity.ApiKey, apiKeySeats.limit)}
          </strong>{" "}
          limit. Upgrade now to unlock more seats and keep the collaboration flowing!
        </>
      )}
      {isStarterTier && (
        <>
          Starter tier has{" "}
          <strong>
            {userSeats.limit} {pluralize(SeatLimitsNotificationEntity.User, userSeats.limit)}
          </strong>{" "}
          limit (including API keys). Update subscription with{" "}
          <strong>Unlimited users add on</strong> or <strong>upgrade to {upgradeTierName}</strong>{" "}
          to unlock more seats and keep the collaboration flowing!
        </>
      )}
      <FeedbackActions>
        <LinkButton variant="contrast" size="small" to="/settings/billing">
          Upgrade
        </LinkButton>
        {isStarterTier && (
          <LinkButton variant="secondary" size="small" to="/settings/billing/subscription">
            Manage subscription
          </LinkButton>
        )}
      </FeedbackActions>
    </Feedback>
  );
};

export default SeatLimitsNotificationLoginPolicies;
